export default __webpack_public_path__ + "static/media/cora.16bc3405.svg";